import { Grid, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import SelectLojaComPesquisa from '../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa'
import SelectMeioPagamento from '../../../../../../../components/SelectsSimpleApiQuery/SelectMeioPagamento'

export default function CCORegistroPagamentoConfig() {

    const { watch, control } = useFormContext()

    return (
        <>
            <Typography mt={1} mb={2}><b>Configuração de registro de pagamento</b></Typography>
            <Grid container spacing={2}>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_registro_pagamento.loja'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectLojaComPesquisa
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => {field.onChange(valor)}}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_registro_pagamento.forma_pagamento'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectMeioPagamento
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                    extraParams={{ loja_id: watch("config_geracao_titulo_receber.loja.id") ?? 1 }}
                                />
                            )
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}
